import { render, staticRenderFns } from "./StorySubscribeView.vue?vue&type=template&id=b4e96cfc&scoped=true&"
import script from "./StorySubscribeView.vue?vue&type=script&lang=ts&"
export * from "./StorySubscribeView.vue?vue&type=script&lang=ts&"
import style0 from "./StorySubscribeView.vue?vue&type=style&index=0&id=b4e96cfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e96cfc",
  null
  
)

export default component.exports